import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  { body: [
    "inonit values your privacy.",
    "This Privacy Policy explains how we collect, use, and protect your information when using the platform.",
  ] },
  { heading: "1. Information We Collect", body: [
    "We may collect:",
    ["name", "username", "email address", "profile photo", "city/location", "event activity", "messages and interactions", "device/browser information", "usage analytics"],
    "If location access is enabled, we may collect approximate or precise location data to improve event discovery and map functionality.",
  ] },
  { heading: "2. How We Use Your Information", body: [
    "We use your information to:",
    ["provide and improve the platform", "personalize event recommendations", "show nearby events", "manage accounts and authentication", "moderate content and ensure safety", "send notifications and updates", "analyze platform performance"],
  ] },
  { heading: "3. Event & Profile Visibility", body: [
    "Certain profile and event information may be visible to other users, including:",
    ["username", "profile image", "hosted events", "joined events", "event attendance counts"],
    "You control some visibility settings inside your account preferences.",
  ] },
  { heading: "4. Data Sharing", body: [
    "We do not sell your personal information.",
    "We may share limited data with trusted service providers used to operate the platform, including:",
    ["authentication providers", "cloud hosting", "analytics services", "map/location services", "storage providers"],
    "These providers only receive the information necessary to perform their services.",
  ] },
  { heading: "5. Cookies & Analytics", body: [
    "inonit may use cookies and analytics tools to:",
    ["maintain sessions", "improve performance", "understand user behavior", "enhance user experience"],
    "You can disable cookies through your browser settings.",
  ] },
  { heading: "6. Data Retention", body: [
    "We retain information as long as necessary to:",
    ["provide the service", "comply with legal obligations", "maintain platform integrity", "preserve historical event analytics"],
    "Archived events may remain associated with user profiles and statistics even after removal from public feeds.",
  ] },
  { heading: "7. Account Deletion", body: [
    "You may request account deletion at any time through your account settings.",
    "Some information may remain temporarily in backups or logs for security and legal purposes.",
  ] },
  { heading: "8. Security", body: [
    "We use industry-standard security measures to protect user data.",
    "However, no system can guarantee absolute security.",
  ] },
  { heading: "9. Children’s Privacy", body: [
    "inonit is not intended for children under 16 years old.",
    "We do not knowingly collect information from children.",
  ] },
  { heading: "10. International Users", body: [
    "By using inonit, you understand that your data may be processed and stored in countries where our infrastructure providers operate.",
  ] },
  { heading: "11. Changes to This Policy", body: [
    "We may update this Privacy Policy periodically.",
    "Continued use of the platform after updates means you accept the revised policy.",
  ] },
  { heading: "12. Contact", body: [
    "For privacy-related questions or requests:",
    "mailto:founder@inonit.app",
  ] },
];

export default function PrivacyPage() {
  return <LegalPage title="Privacy Policy" lastUpdated="Last updated · May 2026" sections={SECTIONS} />;
}
